import styled from 'styled-components'
import Button from '@/components/blocks/Button'

export const SignInStyleWrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  background: url(${({ theme }) => theme.images.signIn}) no-repeat center center;
  background-size: cover;

  ${({ hidden }) => hidden && `
    background: none;
  `}
`

export const LogoContainer = styled.div`
  margin-bottom: 18px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;

   > svg {
    width: 48px;
    height: 48px;
    min-width: 48px;
    min-height: 48px;
  }
`

export const TitleLogo = styled.div`
  font-size: 16px;
  font-weight: 800;
  line-height: 1.2;
  min-height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2px;
  text-align: center;
  white-space: nowrap;
  color: ${({ theme }) => theme.colors.colors.default};
`

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 380px;
  min-height: 375px;
  height: 375px;
  padding: 45px 85px;
  background: ${({ theme }) => theme.colors.backgrounds.default};
  box-shadow: ${({ theme }) => theme.defaultBoxShadow(theme.colors.shadows.widget)};
  border-radius: 4px;

  > svg {
    min-width: 104px;
    min-height: 43px;
    max-height: 43px;
    margin-bottom: 22.5px;
  }

  ${({ hidden }) => hidden && `
    display: none;
  `}

  @media (max-width: 910px) {
    width: 300px;
    padding: 35px 65px;
  }

`

export const Text = styled.div`
  font-weight: bold;
  font-size: 1.4rem;
  line-height: 2rem;
  display: flex;
  white-space: pre-wrap;
  text-align: center;
  margin-top: 10px;
  color: ${({ theme }) => theme.colors.colors.online};
  ${({ error, theme }) => error && `
    color: ${theme.colors.backgrounds.notification.error}
  `};
`

export const StyledButton = styled(Button)`
  color: ${({ theme }) => theme.colors.colors.subTitle};
  text-decoration-line: underline;
  font-size: 1.2rem;
  align-items: center;
  justify-content: center;
  line-height: 3rem;
  margin-top: 10px;
`
